import {WindowDatumInput, WindowsInterface} from "./WindowInterface";

export class Windows implements WindowsInterface {
  public setWindows(windows: any) {
    this.windows = windows;
  }

  public close(id: number): void {
    return this.windows.close(id);
  }

  public getCloseData(id: number): Promise<any> {
    return this.windows.getCloseData(id);
  }

  public open(windowDatumInput: WindowDatumInput): number {
    return this.windows.open(windowDatumInput);
  }

  private windows!: WindowsInterface;
}


export const windows = new Windows();
